import type { IconData } from '@stacksjs/iconify-core'

export const infinite: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.5 9a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7M11 5.5a3.5 3.5 0 1 0 .668-2.057a6.5 6.5 0 0 0-1.001-1.887A5.5 5.5 0 1 1 10 8.663A5.5 5.5 0 1 1 11 5.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default infinite
